import "@shoelace-style/shoelace/dist/components/button/button.js";

import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { ILocation } from "../../models/ILocation";
import { choose } from "lit/directives/choose.js";

import "../ProgressSpinner/ProgressSpinner";

type HomeNavigateControlView = "main" | "acquiring";

@customElement("ds-home-navigate-control")
export class HomeNavigateControl extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .container {
                padding-top: 1em;
            }

            sl-button {
                flex-grow: 1;
            }
        `,
    ];

    @property({ type: String }) propName: any;

    @state() protected _view: HomeNavigateControlView = "main";
    @state() protected _homeLocation?: ILocation;

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._homeLocation = this._kernel.currentHomeLocation.get();
    }

    override render() {
        return html`<div class="container flex-column">
            ${choose(this._view, [
                [
                    "main",
                    () =>
                        html`<sl-button @click=${() => this._setHome()}>Set car position</sl-button>
                            <sl-button
                                ?disabled=${!this._homeLocation}
                                @click=${() => this._clearHome()}
                                >Clear car position</sl-button
                            >
                            <sl-button
                                ?disabled=${!this._homeLocation}
                                @click=${() => this._navigateHome()}
                                >Navigate to car</sl-button
                            >`,
                ],
                [
                    "acquiring",
                    () =>
                        html`<ds-progress-spinner
                            message="Acquiring location"
                        ></ds-progress-spinner>`,
                ],
            ])}
        </div>`;
    }

    private _setHome() {
        navigator.geolocation.getCurrentPosition(
            async (pos: GeolocationPosition) => {
                this._homeLocation = {
                    lat: pos.coords.latitude,
                    lon: pos.coords.longitude,
                };
                this._kernel.currentHomeLocation.set(this._homeLocation);
                this._view = "main";
            },
            () => {
                this._homeLocation = undefined;
                this._view = "main";
            },
            {
                enableHighAccuracy: true,
            }
        );
        this._view = "acquiring";
    }

    private _clearHome() {
        this._kernel.currentHomeLocation.reset();
        this._homeLocation = undefined;
    }

    private _navigateHome() {
        this._kernel.events.raiseEvent("ds-navigate", {
            location: this._homeLocation,
        });
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-home-navigate-control": HomeNavigateControl;
    }
}
